import { SnowplowService } from "~/services/public/Snowplow"

export default defineNuxtPlugin(nuxtApp => {
  const snowplow = new SnowplowService()

  if (import.meta.client) {
    nuxtApp.hook("app:mounted", () => {
      const buttons = document.querySelectorAll(".av-button")
      buttons.forEach(button => {
        button.addEventListener("click", () => {
          // @ts-ignore
          snowplow.trackButtonClick(button.textContent, button.href)
        })
      })

      const textLinks = document.querySelectorAll(".link-quote")
      textLinks.forEach(link => {
        link.addEventListener("click", () => {
          // @ts-ignore
          snowplow.trackLinkClick(link.firstChild.textContent, link.firstChild.href)
        })
      })
    })
  }
})
